import { useState } from "react";
import {
  ArrowLeft,
  Users,
  FileText,
  RefreshCw,
  UserPlus,
  Clock,
  Shield,
} from "lucide-react";
import { Link } from "react-router-dom";
import LicenseDetails from "../components/company-admin/license-details";
import AccountTransfer from "../components/company-admin/account-transfer";
import PagesManagement from "../components/company-admin/pages-management";
import TeamCollaboration from "../components/company-admin/team-collaboration";
import AccountCreation from "../components/company-admin/account-creation";
import ActivityLogs from "../components/company-admin/activity-logs";
import { useSelector } from "react-redux";

export default function CompanyAdminPage() {
  const [activeTab, setActiveTab] = useState("license");

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      {/* <header className="border-b border-gray-200 bg-white">
        <div className="flex h-16 items-center justify-between px-4 md:px-6">
          <div className="flex items-center gap-4">
            <Link to="/userProfile2" className="flex items-center text-gray-500 hover:text-gray-700">
              <ArrowLeft className="h-5 w-5" />
              <span className="ml-2">Back to Dashboard</span>
            </Link>
          </div>
        </div>
      </header> */}

      {/* Main Content */}
      <main className="container mx-auto p-4 md:p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">
            Company Administration
          </h1>
          <p className="text-gray-500">
            Manage your company settings, licenses, teams, and more
          </p>
        </div>

        {/* Tabs */}
        <div className="mb-6">
          <div className="mb-4 grid w-full grid-cols-3 overflow-hidden rounded-lg border border-gray-200 bg-gray-50 md:grid-cols-6">
            <div
              onClick={() => setActiveTab("license")}
              className={`cursor-pointer flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium ${
                activeTab === "license"
                  ? "bg-white text-red-600 shadow-sm"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <Shield className="h-4 w-4" />
              <span className="hidden md:inline">License</span>
            </div>
            <div
              onClick={() => setActiveTab("transfer")}
              className={`cursor-pointer flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium ${
                activeTab === "transfer"
                  ? "bg-white text-red-600 shadow-sm"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <RefreshCw className="h-4 w-4" />
              <span className="hidden md:inline">Transfer</span>
            </div>
            <div
              onClick={() => setActiveTab("pages")}
              className={`cursor-pointer flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium ${
                activeTab === "pages"
                  ? "bg-white text-red-600 shadow-sm"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <FileText className="h-4 w-4" />
              <span className="hidden md:inline">Pages</span>
            </div>
            <div
              onClick={() => setActiveTab("teams")}
              className={`cursor-pointer flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium ${
                activeTab === "teams"
                  ? "bg-white text-red-600 shadow-sm"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <Users className="h-4 w-4" />
              <span className="hidden md:inline">Teams</span>
            </div>
            <div
              onClick={() => setActiveTab("accounts")}
              className={`cursor-pointer flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium ${
                activeTab === "accounts"
                  ? "bg-white text-red-600 shadow-sm"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <UserPlus className="h-4 w-4" />
              <span className="hidden md:inline">Accounts</span>
            </div>
            <button
              onClick={() => setActiveTab("logs")}
              className={`flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium ${
                activeTab === "logs"
                  ? "bg-white text-red-600 shadow-sm"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              <Clock className="h-4 w-4" />
              <span className="hidden md:inline">Logs</span>
            </button>
          </div>

          {/* Tab Content */}
          <div className="mt-4">
            {activeTab === "license" && <LicenseDetails />}
            {activeTab === "transfer" && <AccountTransfer />}
            {activeTab === "pages" && <PagesManagement />}
            {activeTab === "teams" && <TeamCollaboration />}
            {activeTab === "accounts" && <AccountCreation />}
            {activeTab === "logs" && <ActivityLogs />}
          </div>
        </div>
      </main>
    </div>
  );
}
